<template>
     <tr>
        <div class="responsiveTD dynamic4ColExpand" @click="toggleCollapse">
            <td data-label="Well ID">
                {{wellId}}
            </td>
            <td data-label="Operator">
                <router-link :to="{name: 'Operators', params: {operator: operShort}}" class="link">{{operator}}</router-link>
            </td>
            <td data-label="Block">
                {{block}}
            </td>
            <td data-label="Report Date">
                {{reportDate}}
            </td>
            <button data-label="More Information" v-show="expandable" style="cursor: pointer;">
                <svg v-if="!isCollapsed" width="24" height="24">
                    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
                </svg>
                <svg v-else width="24" height="24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                </svg>
            </button>
        </div>
        <td class="expandableTableRow" v-show="expandable" :style="currHeight" style="padding: 0;">
            <div class="expandableTableContent">
                <div class="info2Cols">
                    <div class="category" v-if="general.length > 0">
                        <h6 class="categoryTitle">General</h6>
                        <div v-for="obj in general" :key="obj.field" class="dataItem">
                            <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        </div>
                    </div>
                    <div class="category" v-if="details.length > 0">
                        <h6 class="categoryTitle">Details</h6>
                        <div v-for="obj in details" :key="obj.field" class="dataItem">
                            <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        </div>
                    </div>
                    <div class="category" v-if="contact.length > 0">
                        <h6 class="categoryTitle">Contact</h6>
                        <div v-for="obj in contact" :key="obj.field" class="dataItem">
                            <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import { readFromObj, formatDateLT, formatPhoneNum } from '../../helpers/Formatting.js';

export default {
    name: 'lease-well-activity-item',
    props: [
        "wellActivityItem",
    ],
    data: () => ({
        wellId: null,
        operShort: "",
        operator: null,
        block: null,
        reportDate: null,
        general: [],
        details: [],
        contact: [],
        expandable: false,
        isCollapsed: true,
        expandableHeight: 0,
    }),
    created() {
        var globv = this;
        globv.wellId = globv.wellActivityItem['wellId'];
        globv.operator = globv.wellActivityItem['operator'];
        globv.operShort = globv.wellActivityItem['operShort'];
        globv.block = globv.wellActivityItem['surfaceBlock'];
        globv.reportDate = formatDateLT(globv.wellActivityItem['reportDate']);

        let expectedVariables = [
            {
                varName: "rigName",
                fieldName: "Rig Name"
            },
            {
                varName: "status",
                fieldName: "Status"
            },
            {
                varName: "wellStatus",
                fieldName: "Well Status"
            },
            {
                varName: "protraction",
                fieldName: "Protraction"
            },
            {
                varName: "remark",
                fieldName: "Remark"
            },
        ]

        globv.general = readFromObj(globv.wellActivityItem, expectedVariables);

        expectedVariables = [
            {
                varName: "waterDepth",
                fieldName: "Water Depth",
                unit: " m"
            },
            {
                varName: "pressureTest.ram",
                fieldName: "Ram Pressure Test",
                unit: " psi"
            },
            {
                varName: "pressureTest.annular",
                fieldName: "Annular Pressure Test",
                unit: " psi"
            },
        ]

        globv.details = readFromObj(globv.wellActivityItem, expectedVariables);

        expectedVariables = [
            {
                varName: "name",
                fieldName: "Contact Person's Name"
            },
            {
                varName: "phoneNum",
                fieldName: "Contact Person's Phone #",
                format: formatPhoneNum
            },
        ]

        globv.contact = readFromObj(globv.wellActivityItem['contact'], expectedVariables);

        globv.expandable = globv.general.length > 0 || globv.details.length > 0 || globv.contact.length > 0;
        globv.expandableHeight = (globv.general.length + globv.details.length + globv.contact.length) * 24 + 72;
    },
    methods: {
        toggleCollapse: function() {
            var globv = this;
            if (globv.expandable)
                globv.isCollapsed = !globv.isCollapsed;
        }
    },
    computed: {
        currHeight() {
            var globv = this;

            if (globv.expandable) {
                return {
                    "max-height": globv.isCollapsed ? "0px" : globv.expandableHeight * 5 + 'px'
                }
            }
            
            return {};
        }
    }
}
</script>